import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const MyCourses = lazyRouteComponent(() => import('@/_instructor/my-courses'));

export const Route = createFileRoute('/_instructor/my-courses/')({
  component: () => renderInstructorPage(MyCourses),
});
